export default {
  root: {
    backgroundColor: "#222745"
  }
};
